// Date-only fields (task due date, project and sprint start/end, milestone,
// time entry and burndown dates) are stored as UTC midnight of their calendar
// day. Read with a plain `new Date(value)`, west of UTC they fall on the
// evening before, so the day shows one too early and "overdue" or "delayed"
// flips a day or a week ahead of time. These helpers read them as calendar
// days instead. Real instants (createdAt, updatedAt) do not go through here.

const DAY_MS = 24 * 60 * 60 * 1000;

const pad = (n) => String(n).padStart(2, '0');

/** 'YYYY-MM-DD' of a stored date-only value (also the format of a date input). */
export const dayKey = (value) => new Date(value).toISOString().slice(0, 10);

/** 'YYYY-MM-DD' of a local Date, today by default. */
export const localDayKey = (date = new Date()) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** Local midnight of a stored date-only value, for local calendar arithmetic. */
export const parseDay = (value) => {
  const [year, month, day] = dayKey(value).split('-').map(Number);
  return new Date(year, month - 1, day);
};

/** Whole days from today to a stored date-only value: 0 today, negative once past. */
export const daysUntil = (value) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  // Rounded, so a daylight saving shift in between does not drop a day.
  return Math.round((parseDay(value) - today) / DAY_MS);
};

/** A stored date-only value formatted as its own calendar day. */
export const formatDay = (value, options) => parseDay(value).toLocaleDateString('es-ES', options);
